export const DEFAULT_TENNANT = 'cloudbet';
export const SPORT = 'sports';
export const CASINO = 'casino';
